/**
 * RESPONSIBILITY: the band that closes the Visit page with a way to get in touch.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Link } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { LINK_HINT } from '../hints';

@Section({ name: SectionName.VisitCta, label: 'Visit · Get in touch' })
export class VisitCtaSection {
  @Text({ label: 'Title', maxLength: 300 })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 2000, rows: 2 })
  body!: string;

  @Text({ label: 'Button text', maxLength: 120, default: 'Contact us' })
  ctaLabel!: string;

  @Link({ label: 'Button link', description: `${LINK_HINT} Empty goes to the Contact page.` })
  ctaHref!: string;
}
